const backgroundTransparency =
  import.meta.env.VITE_RELEASE_ENVIRONMENT === 'development' ? '.7' : '1';

export const brandColor = `rgba(35, 67, 97, ${backgroundTransparency})`;
